/*
Note:
Komponen ini dipakai di organization-detail (background gelap)
& resource-detail (background terang).
*/


import React from 'react'
import { useViewport, viewportBreakpoint } from '../utils'

const Label = ({children, isMobile, lightOnMobile}) => {
  return <p className={`text-xs ${lightOnMobile? 'text-white' : 'text-gray-999'} opacity-50`}>{children}</p>
}

const Value = ({children, isMobile, lightOnMobile}) => {
  return <p className={`text-sm leading-tight ${lightOnMobile ? 'text-white' : 'text-gray-444'}`}>{children}</p>
}

const Meta = ({label, value, className, lightOnMobile}) => {
  const { width } = useViewport()
  const breakpoint = viewportBreakpoint.tablet
  const isMobile = width < breakpoint
  // const isDesktop = width >= viewportBreakpoint.desktop

  return (
    <div className={`font-medium ${className}`}>
      <Label isMobile={isMobile} lightOnMobile={lightOnMobile}>{label}</Label>
      <Value isMobile={isMobile} lightOnMobile={lightOnMobile}>{value}</Value>
    </div>
  )
}

export { Meta }